import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import PersonIcon from "@material-ui/icons/Person";
import blue from "@material-ui/core/colors/blue";
import _ from "lodash";

const styles = (theme) => ({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 275,
  },
});

class ClonePlayerSelectDialog extends React.Component {
  state = {
    displayPlayerList: [],
    playerSearch: "",
  };
  componentDidUpdate(prevProps) {
    const currentPlayerList = this.props.playerList;
    const prevPlayerList = prevProps.playerList;
    if (currentPlayerList !== null && prevPlayerList !== null) {
      if (this.props.playerList.length !== prevProps.playerList.length) {
        const playersToDisplay = _.take(this.props.playerList, 30);
        this.setState({
          displayPlayerList: playersToDisplay,
        });
      }
    }
  }
  handleSearchChange = (event) => {
    const playerSearch = event.target.value.toUpperCase();
    let filteredPlayers = _.chain(this.props.playerList)
      .filter(
        (player) =>
          _.includes(player.Player, playerSearch) ||
          _.includes(player.Password, playerSearch)
      )
      .take(30)
      .value();
    if (filteredPlayers.length === 0) {
      filteredPlayers = _.take(this.props.playerList, 10);
    }
    this.setState({
      playerSearch,
      displayPlayerList: filteredPlayers,
    });
  };
  render() {
    const {
      classes,
      open,
      handleClose,
      selectPlayer,
      playerSearch,
    } = this.props;
    const { displayPlayerList } = this.state;
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
      >
        <DialogTitle id="simple-dialog-title">Select a Player</DialogTitle>
        <Typography style={{ padding: 10 }}>
          To create a new player, first select one of your existing players to
          clone. Then you will provide a new password and the new account can be
          added. You can use the dropdown to make a more specific search. ***
          Shows the first 30 results that matches with your search
        </Typography>
        <div>
          <TextField
            id="name"
            label="Search player account to clone"
            className={classes.textField}
            value={playerSearch}
            onChange={this.handleSearchChange}
            margin="normal"
          />
          <List>
            {displayPlayerList.map((player) => (
              <ListItem
                button
                onClick={() => selectPlayer(player)}
                key={`player-select-clone-dialog-${player.IdPlayer}`}
              >
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>
                    <PersonIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={player.Player}
                  secondary={player.Password}
                />
              </ListItem>
            ))}
          </List>
        </div>
      </Dialog>
    );
  }
}

ClonePlayerSelectDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  playerList: PropTypes.array.isRequired,
  handleClose: PropTypes.func.isRequired,
  selectPlayer: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(ClonePlayerSelectDialog);
